var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBookmarkDisactiveIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "current",
    height: "current",
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.5349 8.17244L5.63759 6.90756C5.24477 6.64569 4.73306 6.64569 4.34062 6.90756L2.44331 8.17244C2.34665 8.23699 2.21718 8.1677 2.21718 8.05135V1.31557C2.21718 1.23351 2.28356 1.16713 2.36562 1.16713H7.61295C7.69501 1.16713 7.76139 1.23351 7.76139 1.31557V8.05171C7.76139 8.16806 7.63191 8.23736 7.53526 8.1728L7.5349 8.17244ZM1.05005 0.582469V9.41762C1.05005 9.88191 1.5676 10.1591 1.95384 9.90124L4.66814 8.09183C4.86254 7.96236 5.11566 7.96236 5.31006 8.09183L8.02436 9.90124C8.4106 10.1587 8.92815 9.88191 8.92815 9.41762V0.582469C8.92815 0.26078 8.66737 0 8.34568 0H1.63252C1.31083 0 1.05005 0.26078 1.05005 0.582469Z",
    fill: "#A8B7B2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookmarkDisactiveIcon);
export default __webpack_public_path__ + "static/media/BookmarkDisactiveIcon.a0688e207da23d8752e1efa99af09848.svg";
export { ForwardRef as ReactComponent };